import apiUrl from '../../../constants'
import axios from 'axios'
//import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import Loader from './../shared/loader'
import printJS from 'print-js'
import Printd from 'printd'
import moment from 'moment'
import Pagination from './../shared/pagination'
import common_helper from '../../../common_helper'
import vSelect from 'vue-select'
import {
    WebCam
} from "vue-web-cam"
export default {
	name: 'client',
	components: {
		Pagination,
		DatePicker,
		Loader,
		WebCam,
		vSelect
	},
	data: function () {
		return {
			sellername: '',
			manifest_status: '',
			ifclosed: true,
			displayawnno: false,
			displaycancelawb: false,
			awbnoForSearchCancel: '',
			awbnoForSearch: '',
			showsearchAwbNO: false,
			arrayofsearchAWBNO: [],
			selected: [],
			pickerTransferShow: false,
			VehicleNO: '',
			listTotalmanifestIDData: [],
			currentPage: 1,
			totalPage: 0,
			totalCount: 0,
			pageLimit: 10,
			showSelectWarehouse: false,
			status: '',
			handoveraction: '',
			listHandoverData: [],
			listMaxCountdata: [],
			WarehouseErr: '',
			showSelectClient: false,
			isLoading: false,
			is_Loading: false,
			resultCount: '',
			handname: '',
			poid: '',
			awbno: '',
			shippingcompany: '',
			HandoverPersonName: '',
			awbno: '',
			warehousesearch: '',
			warehousename: '',
			CourierCompany: '',
			listWarehouseData: [],
			listCourierData: [],
			listSellerData: [],
			listfechhanoverclient: [],
			clientidfetch: '',
			clientid: '',
			qtyerror: false,
			errormsg: false,
			msg: '',
			ClientErr: '',
			isdisableValue: false,
			clientname: '',
			saleschannel: '',
			channellist: [],
			listClientData: [],
			manifestid: '',
			ShowDeatils: false,
			HideDetails: false,
			ClosedmanifestShow: false,
			noofboxes: '',
			isb2bflag: false,
			b2border: false,
			rolesSelected: "",
			agrregatorlist: [],
			aggregator: '',
			printManifestModal : false,
			manifest_date : '',
			wmsclientname : '',
			wmswarehousename : '',
			noofAwbs : 0,
			awbList : [],
			loadingText: '<i class="faveImage fa-spinner fa-spin"></i> Loading...',
			loading: false,
			selectfileFlag : false,
			isManifestDocUploaded : false,
			cameraSection : false,
			fileSection : false,
			cameraImage : null,
			selectFirstDevice: true,
			screenshotFormat: "image/jpeg",
			playsinline: false,
			autoplay: true,
			imageCaptured : false,
			cameralist : '',
			file :'',
			showfileselect : false,
			showcameraselect : false,
			cameras : '',
            uploadedImagesCount : 0 ,
			ShowSpoc: false,
			sealID:'',
			validateSeal:false
		}
	},
	computed: {
		isComplete1() {
			if (this.errormsg == true) {
				return false;
			}
			else {
				return true;
			}
		},
		isClosed() {
			if (this.displayawnno == true && this.manifest_status == 'open' && this.ifclosed == true) {
				return true;
			} else {
				return false;
			}
		},
		isCancelExist(){
			if (this.listTotalmanifestIDData.awb_details_cancel && this.listTotalmanifestIDData.awb_details_cancel.length>0) {
				return false;
			} else {
				return true;
			}
		},
		isAWBScan() {
			if (this.manifest_status == 'open' && this.ifclosed == true) {
				return true;
			} else {
				return false;
			}
		},
		ifmanifestID() {
			if (this.manifestid == '' && this.manifested == null && this.manifested == undefined) {
				return true;
			} else {
				return false;
			}
		},
		selectAll: {
			get() {
				return this.selected.length === this.listTotalmanifestIDData.length
			},
			set(value) {
				this.selected = []
				if (value) {
					this.listTotalmanifestIDData.forEach((select) => {
						this.selected.push(select.awb_no)
					})
				}
			}
		},
	},
	created: function () { },
	// when a page loads,mounted() will be call
	mounted() {
		this.pageno = 0
		// this.getClientList()
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.useremail = userdetail.email;
		this.userid = userdetail.userid
		// var temp = this.useremail.split('/');

		this.user_type = userdetail.utype;
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		// this.getcourierlist();
		if (localStorage.getItem("selectedClient") != 'undefined' && localStorage.getItem("selectedClient") !='') {
			this.getSellerlist();
			this.getSalesChannels();
		}
		this.$root.$on('localStorageChanged', (newValue) => {
			// Update your local data
			this.warehouse = newValue;
			this.getcourierlist()
		  });
		// this.getcourierlist();
		switch (this.user_type) {
			case 'system_user':
				this.showSelectWarehouse = true;
				this.showSelectClient = true;
				// this.getWarehouseList();
				// this.getClientList();
				// this.getSalesChannels();

				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				// this.getClientList();
				// this.getWarehouseList();
				// this.getcourierlist();
				// this.getSalesChannels();

				this.showSelectWarehouse = true;
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.showSelectWarehouse = false;
				this.showSelectClient = true;
				// this.getClientList();
				// this.getSalesChannels();


				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}
	},
	methods: {


		dateFormatFRT(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},
		CloseManifestAction() {
			this.ClosedmanifestShow = true;
		},
		async printManifestAction() {
			var today = new Date();
			this.manifest_date = moment(today).format('DD/MM/YYYY HH:mm:ss');
			this.input = ({
				warehouseid: localStorage.getItem("selectedWarehouse"),
				clientid: localStorage.getItem("selectedClient"),
				id: this.manifestid

			});
			let result = await common_helper.getRestApiResponse('POST', 'getAWBNOList', this.input, this.$alertify);
			console.log(result.data.data);
			if (result && !result.errorDATA) {
				if (result.data.errorCode == 0) {
					this.awbList =  result.data.data;
					this.wmsclientname = result.data.data[0].clientname
					this.wmswarehousename = result.data.data[0].warehousename
				}
				else if (result.data.data.errorCode == -1) {
					this.$alertify.error(result.data.data.msg)
				}
			 }
			this.printManifestModal = true;
		},
		closePrintModal(){
            this.printManifestModal = false;
		},
		chooseUpload(){
            this.selectfileFlag = true;
		},
		uploadManifestImage(uploadType){
			if(uploadType == 'file')
			{
				this.fileSection = true;
				this.cameraSection = false;
			}
			else{
				this.fileSection = false;
				this.cameraSection = true;
			}
		},
		cameraSelected() {
            this.$refs.cameraImage.changeCamera(this.cameralist)
        },
        camerass(camlist) {
            this.cameras = camlist
        },
		captureImage() {
            this.$refs.cameraImage.pause()
            this.imageCaptured = true
        },
        resetImage() {
            this.imageCaptured = false
            this.$refs.cameraImage.resume()
        },
		async saveImage(inputtype) {
            try {

                this.showfileselect = false
                this.showcameraselect = false
                if (!this.imageCaptured && inputtype == 'camera') {
                    this.$alert(this.$t('grcList.captureImg'))
                    return false
                } else if (!this.file && inputtype == 'file') {
                    this.$alert(this.$t('grcList.selectImg'))
                    return false
                }
                if (inputtype == 'file') {
                    var imgpath = document.getElementById('file');
                    if (!imgpath.value == "") {
                        var img = imgpath.files[0].size;
                        var imgsize = img / 1024;
                        if (imgsize > 4000) {
                            this.$alert(this.$t('grcList.imgSize4mbErr'))
                            document.getElementById('file').value = null
                            this.file=null
                            return false;
                        }
                    }
                }
                let imageString = ""
                var userToken = window.localStorage.getItem('userToken')
                var myStr = userToken.replace(/"/g, '');
                if (inputtype == "camera") {
                    imageString = this.$refs.cameraImage.capture()
                    if (!common_helper.calculateImageSize(imageString)) {
                        this.$alert(this.$t('grcList.imgSize4mbErr'))
                        this.isLoading = false
                        imageString = ""
                        return false
                    }
                } else {
                    let reader = new FileReader()
                    reader.readAsDataURL(this.file)
                    imageString = await new Promise((resolve, reject) => {
                        reader.onload = function() {
                            this.base64String = reader.result.replace("", "")
                            resolve(this.base64String)
                        }
                    })
                }
                let inputpayload = {
                    clientid : Number(localStorage.getItem("selectedClient")),
					manifestid :  this.manifestid,
					imagestring : imageString
                }
                this.isLoading = true

                let Result = await common_helper.getRestApiResponse('POST', 'UploadImageforManifest', inputpayload, this.$alertify)

				if(Result.data.data.status == true){
					this.$alertify.success("Image Uploaded Successfully");
					this.isLoading = false;
					this.cameraSection = false;
					this.fileSection = false;
					this.selectfileFlag = false;
					this.isManifestDocUploaded = true;
					this.uploadedImagesCount = Result.data.data.imageUploadedCount;
					document.getElementById('file').value = null
				}

            } catch (err) {
				document.getElementById('file').value = null
                console.log(err)
            }
        },
		handleFileUpload() {
            this.file = this.$refs.file.files[0];
            let imageTypes = ['image/jpeg', 'image/png']
            let imageFormat = this.file.type
            let checkFormat = imageTypes.includes(imageFormat)
            if (!checkFormat) {
                this.file = null
                document.getElementById('file').value = null
                this.$alert(this.$t('grcList.imgFormatErr'))
            }
        },
		closeHandoverModal(){
			this.pickerTransferShow = false;
			this.ShowDeatils = false;
			this.cameraSection = false;
			this.fileSection = false;
			this.imageCaptured = false;
			this.selectfileFlag = false;
			//document.getElementById('file').value = '';
			//document.body.classList.remove('modal-open');
			//document.body.classList.remove('modal-backdrop');

		},
		print() {

			this.printfun = true;
			const d = new Printd();
			var buffer = '';


var cssText = `.page-header, .page-header-space {
	height: 100px;
  }

  .page-footer, .page-footer-space {
	height: 70px;

  }

  .page-footer {
	position: fixed;
	margin-top: 2px !important;
	bottom: 0;
	width: 100%;
	border-top: 1px solid black; /* for demo */
	background: yellow; /* for demo */
  }

  .page-header {
	position: fixed;
	top: 0mm;
	width: 100%;
	border-bottom: 1px solid black; /* for demo */
	background: yellow; /* for demo */
  }



  @page {
	margin: 20mm
  }

  @media print {
	 thead {display: table-header-group;}
	 tfoot {display: table-footer-group;}
	 printBody {margin: 0;}
	 button {display: none;}

    }
	table {
		border-collapse: collapse;
	    margin-left:0px !important;

	  }


	`;
			d.print(document.getElementById('printPoContent'), cssText);

		},
		showDeatils() {
			this.ShowDeatils = true;
			this.HideDetails = false;
			this.HandoverPersonName = '';
			this.VehicleNO = '';
		},
		// async getClientList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);

		// 	} else {


		// 		this.input = ({
		// 			warehouseid: this.warehouseid,
		// 		});
		// 		let result = await common_helper.getRestApiResponse('POST', 'getWarehouseAssociatedClientList', this.input, this.$alertify)
		// 		if (result && !result.errorDATA) {
		// 			this.listClientData = result.data.data;
		// 		}

		// 	}
		// },
		// clientSelected() {
		// 	if (this.user_type != 'warehouse_user' && this.clientname != '' && this.clientname != undefined) {

		// 		this.listWarehouseData = []
		// 		this.getWarehouseList();
		// 		this.getcourierlist();
		// 		this.getSalesChannels();
		// 		this.getSellerlist();
		// 		if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 			this.warehouse = this.warehouseid = '';
		// 		} else {
		// 			this.warehouse = ''
		// 		}
		// 	} else {
		// 		if (this.warehouseid && this.clientname) {
		// 			this.warehousename = this.warehouseid
		// 			this.getSalesChannels();
		// 			this.getSellerlist();
		// 			this.getcourierlist();
		// 		}
		// 	}
		// 	this.listcancelPutawayReportData = [];
		// 	this.pageno = this.totalPage = 0;

		// },
		onchange() {
			this.manifestid = '';
			this.awbno = '';
			if (this.CourierCompany && this.CourierCompany == 'Others') {
				this.$prompt("Enter Courier Company").then(text => {
					if (text && text != '' && text != null) {

						this.listCourierData.push({
							'couriername': text.trim(),
							//  'othersflag':true
						})
						this.CourierCompany = text.trim()
						this.$alert('Courier Company Added', text)
					} else {
						this.$alert('Courier Company Not Added', text)
					}
				})
			}


		},
		async onchangecourier() {
			this.manifestid = '';
			this.awbno = '';
			if (this.CourierCompany && this.CourierCompany == 'Others') {
				this.$prompt("Enter Courier Company").then(text => {
					if (text && text != '' && text != null) {

						this.listCourierData.push({
							'couriername': text.trim(),
							//  'othersflag':true
						})
						this.CourierCompany = text.trim()
						this.$alert('Courier Company Added', text)
					} else {
						this.$alert('Courier Company Not Added', text)
					}
				})
			}
			if(this.CourierCompany=='')
				return;

			this.input = ({
				shippingcompany: this.CourierCompany,
				clientid: window.localStorage.getItem("selectedClient"),
			})
			this.agrregatorlist = []
			let result = await common_helper.getRestApiResponse('POST', 'getcourieraggregatormapping', this.input)
			if (result && !result.errorDATA) {
				if (result.data.data.data && result.data.data.data.length > 0) {
					//this.agrregatorlist.push("No Aggregator")
					result.data.data.data.forEach(e => {
						if (e.shippingprovider !== "") {
							this.agrregatorlist.push(e.shippingprovider)
						}
					})
				}
			}

		},
		sam1111() {
			console.log("sssss");
			console.log(this.aggregator, "aggregator");
		},
		async checkinput() {
			this.pageno = 0;
			this.awbnoForSearch = '';
			if (this.awbno == '' || this.awbno == null) {
				this.$alertify.error(this.$t('packingb2b.b2bPacking.modal.awbNoError'))

				return false;
			}

			if (this.showSelectWarehouse == true) {
				this.warehouseid = this.warehousename
			}
			for (var i = 0; i < this.channellist.length; i++) {
				if (this.channellist[i].channel_name == this.saleschannel) {
					this.channel_id = this.channellist[i].channel_id
				}
			}
			this.isLoading = true;
			this.input = ({
				courier_name: this.CourierCompany,
				channel_name: this.saleschannel,
				channel_id: this.channel_id,
				awbno: this.awbno.trim(),
				clientid: window.localStorage.getItem("selectedClient"),
				manifestid: this.manifestid,
				noofboxes: this.noofboxes,
				isb2b: this.b2border,
				aggregator: this.aggregator

			});
			let result = await common_helper.getRestApiResponse('POST', 'AddAwbManifestDetails', this.input, this.$alertify)
			if (result && !result.errorDATA) {
				if (result.data.data.ErrorCode == 0) {
					this.$alertify.success(result.data.data.msg)
					this.getManifestDetailsByManifestID();
					this.removeawbfrominput();
				} else if (result.data.data.ErrorCode == -1) {
					this.isLoading = true;
					this.$alertify.error(result.data.data.msg)
				}
				// if (result.data.data[0].ErrorCode == -1) {
				//   this.$alertify.error(result.data.data[0].msg)
				// }
				this.isLoading = false;
			}
		},
		async removeCancelAWB(){
			if(this.awbnoForSearchCancel.trim()!='')
			{
				this.pageno = 0;

				this.input = ({
					warehouseid: window.localStorage.getItem("selectedWarehouse"),
					clientid: localStorage.getItem("selectedClient"),
					manifestid: this.manifestid,
					awbno: this.awbnoForSearchCancel

				});
				let result = await common_helper.getRestApiResponse('POST', 'CancelAwbFromManifest', this.input, this.$alertify)
				if (result && !result.errorDATA) {
					if (result.data.data.ErrorCode == 0) {
						this.$alertify.success(result.data.data.msg)
					} else if (result.data.data.ErrorCode == -1) {
						this.$alertify.error(result.data.data.msg)
					}
					this.awbnoForSearchCancel = ''
					this.getManifestDetailsByManifestID();
				}
			}
		},
		removeawbfrominput() {
			this.awbno = '';
		},
		async getcourierlist() {
			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.WarehouseErr = this.$t('common.warehouseError');
				return false;
			}
			this.pageno = 0;

			// if (this.showSelectWarehouse == true) {
			// 	this.warehouseid = this.warehousename
			// }

			if(this.warehouseid == ""){
				return false;
			}
			if(!this.saleschannel || this.saleschannel == ""){
				return false;
			}
			this.input = ({
				warehouseid: window.localStorage.getItem("selectedWarehouse"),
				clientid: window.localStorage.getItem("selectedClient"),
				saleschannel : this.saleschannel
			});
			let result = await common_helper.getRestApiResponse('POST', 'courierMasterListManifestNew', this.input, this.$alertify)
			if (result && !result.errorDATA) {
				this.listCourierData = result.data.data;

			}

		},
		async getSellerlist() {
			this.pageno = 0;

			this.input = ({
				clientid: window.localStorage.getItem("selectedClient")
			});
			let result = await common_helper.getRestApiResponse('POST', 'getSellerListClientWise', this.input, this.$alertify)
			if (result && !result.errorDATA) {
				this.listSellerData = result.data.data;
			}

		},
		async getManifestDetailsByManifestID() {
			this.pageno = 0;

			this.input = ({
				clientid: window.localStorage.getItem("selectedClient"),
				manifestid: this.manifestid

			});
			let result = await common_helper.getRestApiResponse('POST', 'getManifestDetailsByManifestID', this.input, this.$alertify)
			if (result && !result.errorDATA) {
				this.listTotalmanifestIDData = result.data.data.data;
				if (this.listTotalmanifestIDData.awb_details.length == 0) {
					this.displayawnno = false;
					if(this.listTotalmanifestIDData.awb_details_cancel.length>0)
					{
						this.displayawnno = true;
					}

				} else {
					this.noofAwbs = this.listTotalmanifestIDData.awb_details.length
					this.displayawnno = true;
				}
			}

		},
		async remove(data) {
			this.pageno = 0;

			this.input = ({
				warehouseid: window.localStorage.getItem("selectedWarehouse"),
				clientid: window.localStorage.getItem("selectedClient"),
				manifestid: this.manifestid,
				awbno: data.awb_no

			});
			let result = await common_helper.getRestApiResponse('POST', 'RemoveAwbFromManifest', this.input, this.$alertify)
			if (result && !result.errorDATA) {
				if (result.data.data.ErrorCode == 0) {
					this.$alertify.success(result.data.data.msg)
				} else if (result.data.data.ErrorCode == -1) {
					this.$alertify.error(result.data.data.msg)
				}
				this.getManifestDetailsByManifestID();
			}

		},
		// async getWarehouseList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("warehouseList") !== null) {

		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {

		// 		this.input = ({
		// 			'clientid': this.clientname ? this.clientname : this.clientid,
		// 		});
		// 		let result = await common_helper.getRestApiResponse('POST', 'getClientAssociatedWarehouseList', this.input, this.$alertify)
		// 		if (result && !result.errorDATA)
		// 			this.listWarehouseData = result.data.data;

		// 	}
		// },

		getHandoverSearch() {
			this.currentPage = 1;
		},
		SearchAwb() {
			this.showsearchAwbNO = true;
			this.arrayofsearchAWBNO = [];

			if (this.awbnoForSearch != '' && this.awbnoForSearch != null) {
				for (var i = 0; i < this.listTotalmanifestIDData.awb_details.length; i++) {
					if (this.listTotalmanifestIDData.awb_details[i].awb_no == this.awbnoForSearch) {
						this.arrayofsearchAWBNO.push(this.awbnoForSearch)

					}

				}
			} else {
				this.arrayofsearchAWBNO = [];
				this.showsearchAwbNO = false;
			}

		},
		dateFormat(date, toFrom) {
			if (!toFrom)
				toFrom = '00:00:00'
			else
				toFrom = '23:59:59'
			if (!date)
				return '';
			return moment(date).format('YYYY-MM-DD ' + toFrom);
		},
		newmanifest() {
			this.ifclosed = true;
			this.$validator.validateAll().then(async (result) => {
				if (!result) {
					console.log('form is invalid', this.model)
					return false;
				} else {
					this.pageno = 0;
					if (this.showSelectWarehouse == true) {
						this.warehouseid = this.warehousename
					}
					for (var i = 0; i < this.listCourierData.length; i++) {
						if (this.listCourierData[i].couriername == this.CourierCompany) {
							this.courierid = this.listCourierData[i].courierid
						}
					}
					for (var i = 0; i < this.channellist.length; i++) {
						if (this.channellist[i].channel_name == this.saleschannel) {
							this.channel_id = this.channellist[i].channel_id
						}
					}

					this.input = ({
						warehouseid: window.localStorage.getItem("selectedWarehouse"),
						courier_name: this.CourierCompany,
						channel_name: this.saleschannel,
						channel_id: this.channel_id,
						courierid: this.courierid,
						userid: this.userid,
						clientid: window.localStorage.getItem("selectedClient"),
						sellername: this.sellername,
						isb2b: this.b2border,
						aggregator: this.aggregator

					});
					let result = await common_helper.getRestApiResponse('POST', 'generateManifest', this.input, this.$alertify)
					if (result && !result.errorDATA) {

						if (result.data.data.ErrorCode == 0) {
							this.$alertify.success(result.data.data.msg)
							this.manifestid = result.data.data.data.id;
							this.manifest_status = result.data.data.data.manifest_status;
							this.getManifestDetailsByManifestID()
						} else if (result.data.data.ErrorCode == -1) {
							this.$alertify.error(result.data.data.msg)
						}
					}

				}

			}).catch(() => {
				console.log('errors exist', this.errors)
			});

		},
		openManifest() {
			this.ifclosed = true;
			this.$validator.validateAll().then(async (result) => {
				if (!result) {
					console.log('form is invalid', this.model)
					return false;
				} else {
					this.pageno = 0;

					if (this.showSelectWarehouse == true) {
						this.warehouseid = this.warehousename
					}
					for (var i = 0; i < this.listCourierData.length; i++) {
						if (this.listCourierData[i].couriername == this.CourierCompany) {
							this.courierid = this.listCourierData[i].courierid
						}
					}
					for (var i = 0; i < this.channellist.length; i++) {
						if (this.channellist[i].channel_name == this.saleschannel) {
							this.channel_id = this.channellist[i].channel_id
						}
					}


					// for (var i = 0; i < this.listClientData.length; i++)
					// {
					// 	if (Number(this.listClientData[i].clientid) == Number(this.clientname)) {
					// 		this.wmsclientname = this.listClientData[i].clientname;
					// 	}
					// }
					// for (var i = 0; i < this.listWarehouseData.length; i++)
					// {
					// 	if (Number(this.listWarehouseData[i].warehouseid) == Number(this.warehouseid)) {
					// 		this.wmswarehousename = this.listWarehouseData[i].warehousename;
					// 	}
					// }

					this.input = ({
						warehouseid: window.localStorage.getItem("selectedWarehouse"),
						channel_id: this.channel_id,
						courierid: this.courierid,
						clientid: window.localStorage.getItem("selectedClient"),
						sellername: this.sellername,
						couriername: this.CourierCompany,
						isb2b: this.b2border,
						aggregator: this.aggregator

					});

					let result = await common_helper.getRestApiResponse('POST', 'openManifest', this.input, this.$alertify)
					if (result && !result.errorDATA) {
						if (result.data.data.ErrorCode == 0) {
							this.manifestid = result.data.data.data[0].manifestid;
							this.getManifestDetailsByManifestID()
							this.manifest_status = result.data.data.data[0].manifest_status;
							this.$alertify.success(result.data.data.msg)
                            //this.$alertify.success(this.$t(`apiErrors.${result.data.data.errorLabel}`))
						} else if (result.data.data.ErrorCode == -1) {
							this.$alertify.error(result.data.data.msg)
						}
					}

				}
			}).catch(() => {
				console.log('errors exist', this.errors)
			});


		},
		async getSalesChannels() {

			this.input = { clientid: window.localStorage.getItem("selectedClient") }
			let result = await common_helper.getRestApiResponse('POST', 'GetChannelList', this.input, this.$alertify)
			if (result && !result.errorDATA) {
				this.channellist = result.data.data.data;
				this.getcourierlist()
			}

		},
		saveHandover() {

			this.$validator.validateAll().then(async (result) => {
				if (!result) {
					console.log('form is invalid', this.model)
					return false;
				} else {
					this.pickerTransferShow = false;
					if (this.showSelectWarehouse == true) {
						this.warehouseid = this.warehousename
					}
					// if (this.qtyerror == true) {
					//   return false;
					// }
					for (var i = 0; i < this.channellist.length; i++) {
						if (this.channellist[i].channel_name == this.saleschannel) {
							this.channel_id = this.channellist[i].channel_id
						}
					}
					this.input = {
						'warehouseid': window.localStorage.getItem("selectedWarehouse"),
						'vehicle_no': this.VehicleNO,
						'handover_person': this.HandoverPersonName,
						'channel_id': this.channel_id,
						'clientid': window.localStorage.getItem("selectedClient"),
						'manifestid': this.manifestid,
						'useremail': this.useremail,
						'sealid':this.sealID?this.sealID:""
					}
					this.is_Loading =true;

					let result = await common_helper.getRestApiResponse('POST', 'HandOverManifest', this.input, this.$alertify)
					if (result && !result.errorDATA) {
						if (result.data.data.ErrorCode == 0) {
							this.$alertify.success(result.data.data.msg);
							this.is_Loading =false;
							this.resetaddDeatilsForm();

						} else if (result.data.data.ErrorCode == -1) {
							this.$alertify.error(this.$t('manifesthandover.manifestNotFound'))
							this.pickerTransferShow = false;
							// this.resetaddDeatilsForm();

						}
						else if (result.data.data.ErrorCode == -2) {
							this.$alertify.error(result.data.data.msg)
							this.pickerTransferShow = false;
							this.getManifestDetailsByManifestID();
							this.ClosedmanifestShow = false;
							this.ifclosed = true;

							this.manifest_status = 'open'
							this.HideDetails = false;
							this.ShowDeatils = true
							// this.resetaddDeatilsForm();
						}
					}
					this.is_Loading =false;

				}

			}).catch(() => {
				this.is_Loading =false;
				console.log('errors exist', this.errors)
			});



		},
		async handoverAction() {
			this.input = ({
                clientid: window.localStorage.getItem("selectedClient"),
                manifestid: this.manifestid

            });
			this.input1 = ({
                clientid: window.localStorage.getItem("selectedClient"),
				manifestid : this.manifestid
            });
			let result = await common_helper.getRestApiResponse('POST', 'getManifestDetailsByManifestID', this.input, this.$alertify)
			let isimageUploaded = result.data.data.data.imageupload_initiated;

			if(isimageUploaded > 0)
			{
				this.isManifestDocUploaded = true;
				this.uploadedImagesCount = isimageUploaded;
			}
			else
			{
				this.isManifestDocUploaded = false;
				this.uploadedImagesCount = 0;
			}
			this.pickerTransferShow = true;
			this.HideDetails = true;
			this.ShowDeatils = false
			let checkIsSpoc = await common_helper.getRestApiResponse('POST', 'checkClientSpocFlag',  this.input1, this.$alertify) 
			if(checkIsSpoc.data.data.spokenabled){
			  this.ShowSpoc = true;
			  if(ckIsSpoc.data.data.validate){
				this.validateSeal = true
			  }else{
				this.validateSeal = false
			  }
			}else{
              this.ShowSpoc = false;
			}
			this.HandoverPersonName = '';
			this.VehicleNO = '';
			this.sealID =''
			this.ClosedmanifestShow = false;
		},

		async CloseManifest() {
			this.pageno = 0;
			this.ClosedmanifestShow = false;
			this.ifclosed = false;
			this.is_Loading = true;

			if (this.showSelectWarehouse == true) {
				this.warehouseid = this.warehousename
			}
			for (var i = 0; i < this.listCourierData.length; i++) {
				if (this.listCourierData[i].couriername == this.CourierCompany) {
					this.courierid = this.listCourierData[i].courierid
				}
			}
			for (var i = 0; i < this.channellist.length; i++) {
				if (this.channellist[i].channel_name == this.saleschannel) {
					this.channel_id = this.channellist[i].channel_id
				}
			}
			this.input = ({
				warehouseid: window.localStorage.getItem("selectedWarehouse"),
				channel_id: this.channel_id,
				clientid: window.localStorage.getItem("selectedClient"),
				manifestid: this.manifestid


			});
			let result = await common_helper.getRestApiResponse('POST', 'CloseManifest', this.input, this.$alertify)
			if (result && !result.errorDATA) {
				if (result.data.data.ErrorCode == 0) {
					this.$alertify.success(result.data.data.msg)
					this.ClosedmanifestShow = false;
					this.ifclosed = false;
					this.is_Loading = false;
					this.manifest_status = 'close';
				} else if (result.data.data.ErrorCode == -1) {
					this.$alertify.error(result.data.data.msg)
					this.ClosedmanifestShow = false;
					this.ifclosed = true;
					this.is_Loading = false;
				}
				else if (result.data.data.ErrorCode == -2) {

					this.getManifestDetailsByManifestID();
					this.$alertify.error(result.data.data.msg)
					this.ClosedmanifestShow = false;
					this.ifclosed = true;
					this.is_Loading = false;
				}
			}

		},
		resetaddDeatilsForm() {
			this.agrregatorlist = []
			this.aggregator = ''
			this.sellername = '';
			this.warehousename = '';
			this.HandoverPersonName = '';
			this.VehicleNO = '';
			this.awbno = '';
			this.$validator.reset();
			this.CourierCompany = '';
			this.manifestid = '';
			this.awbnoForSearch = '';
			this.msg = '';
			this.errormsg = false;
			this.isdisableValue = false;
			this.saleschannel = '';
			this.clientname = '';
			this.ShowDeatils = false
			this.HideDetails = false;
			this.pickerTransferShow = false;
			this.ClosedmanifestShow = false;
			this.displayawnno = false;
			this.displaycancelawb = false;
			this.noofboxes = '';
			this.awbnoForSearchCancel = '';
			this.isb2bflag = false;
			this.selectfileFlag = false;
			this.sealID = '';
		},
		resetaddDeatilsForm2() {
			this.awbno = '';
			this.msg = '';
			this.errormsg = false;
			this.isdisableValue = false;
			this.noofboxes = '';
            this.selectfileFlag = false;
		},

	}
}


// WEBPACK FOOTER //
// ./src/views/components/manifesthandover/manifesthandover.component.js